import React from 'react';
import { findDOMNode } from 'react-dom';
import { TweenLite } from "gsap";
import { isMobile } from "react-device-detect";

export default {
    
    reset(SlideForm) {
        let FormNode = findDOMNode(SlideForm);

        FormNode.querySelector('.loader').style.display = 'none';
        FormNode.querySelector('.success-msg').style.display = 'none';

        let labels = [...FormNode.getElementsByClassName('input__label')],
            graphics = [...FormNode.getElementsByClassName('graphic--nao')];

        labels.map(item => {
            item.style.color = '#fff';
        });

        graphics.map(item => {
            item.style.stroke = '#fff';
        });

        FormNode.querySelector('.input-enquiry').style.borderColor = '#fff';
        FormNode.querySelector('.form-row').style.display = 'block';
    },

    showLoader(SlideForm) {
        let FormNode = findDOMNode(SlideForm);

        FormNode.getElementsByClassName('form-row')[0].style.display = 'none';
        FormNode.getElementsByClassName('loader')[0].style.display = 'block';
        this.scrollUp(FormNode);
    },

    hideLoader(SlideForm) {
        let FormNode = findDOMNode(SlideForm);

		FormNode.getElementsByClassName('loader')[0].style.display = 'none';

        setTimeout(() => {
            FormNode.getElementsByClassName('form-row')[0].style.display = 'block';
            FormNode.getElementsByClassName('success-msg')[0].style.display = 'none';
        }, 10000);
    },

    showErrors(SlideForm) {
        let FormNode = findDOMNode(SlideForm);

        FormNode.getElementsByClassName('loader')[0].style.display = 'none';
        FormNode.getElementsByClassName('form-row')[0].style.display = 'block';
        FormNode.getElementsByClassName('error-msg')[0].style.display = 'block';
    },

    scrollUp() {
        if (isMobile) {
            let formContainer = document.querySelector('.slide-form');
            TweenLite.to(formContainer, 0.5, {scrollTo: 0});
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/forms/SlideForm/animations.js